// React import
import React from "react";
import "./Upgrade.css";
import { bindActionCreators } from "redux";
import { changeUserData, hideNotification, setPage, showNotification } from "../../actions";
import { connect } from "react-redux";
// Components imports
import TonWalletButton from "../TonWalletButton";
import PayStarsButton from "./PayStarsButton";
import { PayTonButton } from "./PayTonButton";
// Consts imports
import {
    AI_LEVEL,
    BASIC,
    FREE,
    PREMIUM,
    PRO,
    RESTORE,
    RESTORE_ENERGY,
    SUBSCRIPTION,
    UPGRADE_AI_LEVEL,
    UPGRADE_SECTION_LEVEL,
    UPGRADE_SECTION_MAIN,
    UPGRADE_SECTION_RESTORE,
    UPGRADE_SECTION_SUBSCRIPTION,
    UPGRADE_SECTION_SUBSCRIPTION_BASIC,
    UPGRADE_SECTION_SUBSCRIPTION_PREMIUM,
    UPGRADE_SECTION_SUBSCRIPTION_PRO,
    UPGRADE_SUBSCRIPTION_BASIC,
    UPGRADE_SUBSCRIPTION_PREMIUM,
    UPGRADE_SUBSCRIPTION_PRO
} from "../../consts/consts";

function RestoreEnergyButton(props) {

    const { changeSection } = props;

    return (
        <div className={"upgrade__button"} onClick={() => changeSection(UPGRADE_SECTION_RESTORE)}>
            <span className="upgrade__button-text">Restore energy</span>
        </div>
    )
}

function UpgradeAiLevelButton(props) {

    const { aiLevel, changeSection } = props;
    const aiLevelInt = parseInt(aiLevel);

    if(aiLevelInt >= 5) {
        return null;
    } else {
        return (
            <div className={"upgrade__button"} onClick={() => changeSection(UPGRADE_SECTION_LEVEL)}>
                <span className="upgrade__button-text">Upgrade to AI level {(aiLevelInt + 1).toString()}</span>
            </div>
        )
    }
}

function BackButton(props) {

    const { section, changeSection } = props;

    return (
        <div className={"upgrade__button__back"} onClick={() => changeSection(section)}>
            <span className="upgrade__button-text">Back</span>
        </div>
    )
}

function SubscriptionBasicButton(props) {

    const { section, changeSection } = props;

    return (
        <div className={"upgrade__button"} onClick={() => changeSection(section)}>
            <span className="upgrade__button-text">Basic</span>
        </div>
    )
}

function SubscriptionProButton(props) {

    const { section, changeSection } = props;

    return (
        <div className={"upgrade__button"} onClick={() => changeSection(section)}>
            <span className="upgrade__button-text">Pro</span>
        </div>
    )
}

function SubscriptionPremiumButton(props) {

    const { section, changeSection } = props;

    return (
        <div className={"upgrade__button"} onClick={() => changeSection(section)}>
            <span className="upgrade__button-text">Premium</span>
        </div>
    )
}

function UpgradeSubscriptionButton(props) {

    const { changeSection } = props;
    return (
        <div className={"upgrade__button"} onClick={() => changeSection(UPGRADE_SECTION_SUBSCRIPTION)}>
            <span className="upgrade__button-text">Upgrade subscription (+30 days)</span>
        </div>
    )
}

class Upgrade extends React.Component {

    constructor(props) {
        super(props);

        // Инициализация state
        this.state = {
            section: UPGRADE_SECTION_MAIN,
            energyRestored: false,  // Энергия восстановлена
            subscriptionActive: false,  // Подписка активна
            upgradeInProgress: false,  // Обновление в процессе
        };

        // Привязка методов (опционально)
        this.handleEnergyRestore = this.handleEnergyRestore.bind(this);
        this.handleSubscriptionUpgrade = this.handleSubscriptionUpgrade.bind(this);
        this.handleUpgradeInProgress = this.handleUpgradeInProgress.bind(this);

        this.changeSection = this.changeSection.bind(this);
    }

    setNotification = (message, duration = 750) => {
        const { showNotification, hideNotification } = this.props;
        showNotification({message: message, duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    changeSection(section) {
        this.setState({ section: section });
    }

    // Метод для обработки восстановления энергии
    handleEnergyRestore() {
        this.setState({ energyRestored: true });  // Обновляем состояние, что энергия восстановлена
    }

    // Метод для обработки обновления подписки
    handleSubscriptionUpgrade() {
        this.setState({ subscriptionActive: true });  // Обновляем состояние, что подписка активна
    }

    // Метод для обработки процесса обновления
    handleUpgradeInProgress() {
        this.setState({ upgradeInProgress: true });  // Обновляем состояние, что обновление в процессе
    }

    render() {
        const {
            ai_level,
            id,
            token,
            subscription
        } = this.props.userData;
        const { changeUserData } = this.props;

        if (this.state.section === UPGRADE_SECTION_MAIN) {
            return (
                <div className="upgrade noselect">
                    <div className={"upgrade__buttons"}>
                        <RestoreEnergyButton  aiLevel={ai_level} changeSection={this.changeSection}/>
                        <UpgradeAiLevelButton aiLevel={ai_level} changeSection={this.changeSection}/>
                        <UpgradeSubscriptionButton changeSection={this.changeSection}/>
                    </div>
                    <TonWalletButton/>
                </div>
            );
        } else if (this.state.section === UPGRADE_SECTION_LEVEL) {
            return (
                <div className="upgrade noselect">
                    <div className={"upgrade__buttons"}>
                        <PayTonButton tgid={id}
                                      subscription={subscription}
                                      type={AI_LEVEL}
                                      aiLevel={ai_level}
                                      token={token}
                                      setNotification={this.setNotification}
                                      changeSection={this.changeSection}
                                      changeUserData={changeUserData}/>
                        <PayStarsButton type={UPGRADE_AI_LEVEL}
                                        aiLevel={ai_level}
                                        subscription={subscription}
                                        tgid={id}
                                        token={token}
                                        changeSection={this.changeSection}
                                        setNotification={this.setNotification}
                                        changeUserData={changeUserData}/>
                        <BackButton section = {UPGRADE_SECTION_MAIN} changeSection={this.changeSection}/>
                    </div>
                    <TonWalletButton/>
                </div>
            );
        } else if (this.state.section === UPGRADE_SECTION_RESTORE) {
              return (
                <div className="upgrade noselect">
                    <div className={"upgrade__buttons"}>
                        <PayTonButton tgid={id}
                                      subscription={subscription}
                                      type={RESTORE}
                                      aiLevel={ai_level}
                                      token={token}
                                      setNotification={this.setNotification}
                                      changeSection={this.changeSection}
                                      changeUserData={changeUserData}/>

                        <PayStarsButton type={RESTORE_ENERGY}
                                        aiLevel={ai_level}
                                        subscription={subscription}
                                        tgid={id}
                                        token={token}
                                        changeSection={this.changeSection}
                                        setNotification={this.setNotification}
                                        changeUserData={changeUserData}/>
                        <BackButton section = {UPGRADE_SECTION_MAIN} changeSection={this.changeSection}/>
                    </div>
                    <TonWalletButton/>
                </div>
            );
        } else if (this.state.section === UPGRADE_SECTION_SUBSCRIPTION) {

            let basic = null, pro = null, premium = null;
            if (subscription === FREE || subscription === BASIC) {
                basic = (<SubscriptionBasicButton section = {UPGRADE_SECTION_SUBSCRIPTION_BASIC} changeSection={this.changeSection}/>)
            }
            if (subscription === FREE || subscription === BASIC || subscription === PRO) {
                pro = (<SubscriptionProButton section = {UPGRADE_SECTION_SUBSCRIPTION_PRO} changeSection={this.changeSection}/>)
            }
            if (subscription === FREE || subscription === BASIC || subscription === PRO || subscription === PREMIUM) {
                premium = (<SubscriptionPremiumButton section = {UPGRADE_SECTION_SUBSCRIPTION_PREMIUM} changeSection={this.changeSection}/>)
            }

            return (
                <div className="upgrade noselect">
                    <div className={"upgrade__buttons"}>
                        {basic}
                        {pro}
                        {premium}
                        <BackButton section = {UPGRADE_SECTION_MAIN} changeSection={this.changeSection}/>
                    </div>
                    <TonWalletButton/>
                </div>
            );
        } else if (this.state.section === UPGRADE_SECTION_SUBSCRIPTION_BASIC) {
            return (
                <div className="upgrade noselect">
                    <div className={"upgrade__buttons"}>
                        <PayTonButton tgid={id}
                                      subscription={BASIC}
                                      type={SUBSCRIPTION}
                                      aiLevel={ai_level}
                                      token={token}
                                      setNotification={this.setNotification}
                                      changeSection={this.changeSection}
                                      changeUserData={changeUserData}/>
                        <PayStarsButton type={UPGRADE_SUBSCRIPTION_BASIC}
                                        aiLevel={ai_level}
                                        subscription={subscription}
                                        tgid={id}
                                        token={token}
                                        changeSection={this.changeSection}
                                        setNotification={this.setNotification}
                                        changeUserData={changeUserData}/>
                        <BackButton section = {UPGRADE_SECTION_SUBSCRIPTION} changeSection={this.changeSection}/>
                    </div>
                    <TonWalletButton/>
                </div>
            );
        } else if (this.state.section === UPGRADE_SECTION_SUBSCRIPTION_PRO) {
            return (
                <div className="upgrade noselect">
                    <div className={"upgrade__buttons"}>
                        <PayTonButton tgid={id}
                                      subscription={PRO}
                                      type={SUBSCRIPTION}
                                      aiLevel={ai_level}
                                      token={token}
                                      setNotification={this.setNotification}
                                      changeSection={this.changeSection}
                                      changeUserData={changeUserData}/>
                        <PayStarsButton type={UPGRADE_SUBSCRIPTION_PRO}
                                        aiLevel={ai_level}
                                        subscription={subscription}
                                        tgid={id}
                                        token={token}
                                        changeSection={this.changeSection}
                                        setNotification={this.setNotification}
                                        changeUserData={changeUserData}/>
                        <BackButton section = {UPGRADE_SECTION_SUBSCRIPTION} changeSection={this.changeSection}/>
                    </div>
                    <TonWalletButton/>
                </div>
            );
        } else if (this.state.section === UPGRADE_SECTION_SUBSCRIPTION_PREMIUM) {
            return (
                <div className="upgrade noselect">
                    <div className={"upgrade__buttons"}>
                        <PayTonButton tgid={id}
                                      subscription={PREMIUM}
                                      type={SUBSCRIPTION}
                                      aiLevel={ai_level}
                                      token={token}
                                      setNotification={this.setNotification}
                                      changeSection={this.changeSection}
                                      changeUserData={changeUserData}/>
                        <PayStarsButton type={UPGRADE_SUBSCRIPTION_PREMIUM}
                                        aiLevel={ai_level}
                                        subscription={subscription}
                                        tgid={id}
                                        token={token}
                                        changeSection={this.changeSection}
                                        setNotification={this.setNotification}
                                        changeUserData={changeUserData}/>
                        <BackButton section = {UPGRADE_SECTION_SUBSCRIPTION} changeSection={this.changeSection}/>
                    </div>
                    <TonWalletButton/>
                </div>
            );
        }


    }
}

const mapStateToProps = ({page, userData, notification}) => ({page, userData, notification});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setPage,
            showNotification: showNotification,
            hideNotification: hideNotification,
            changeUserData: changeUserData
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Upgrade);